import { z } from 'zod';
/**
 * Keyset ("cursor") pagination.
 *
 * Offset pagination is wrong for a live transcript: messages arriving while a
 * client scrolls back shift the window, so rows get skipped or repeated. A
 * cursor anchored to a specific row is stable under concurrent inserts and stays
 * fast at depth.
 *
 * The cursor is **opaque**. Clients pass back exactly what they received and
 * never parse it - its encoding is a server-side storage detail.
 */
export const paginationQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(50),
    /** Fetch the page immediately older than this cursor. Omit for the newest page. */
    before: z.string().min(1).optional(),
});
/** Builds a validator for a concrete `Page<T>`, e.g. `pageSchema(messageSchema)`. */
export function pageSchema(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
        hasMore: z.boolean(),
    });
}
//# sourceMappingURL=pagination.js.map